import reqProduto from "../../../../services/reqMultiTenant/reqProduto";
import MainReportMatrix from "../../matrix";
import FilterReportDateItens from "../../../../components/filter/reportDateItens/filter";

const ReportEstoqueBaixo = (props) => {
	const options = {
		title: "Estoque Baixo",
		subTitle: "Produtos com estoque abaixo ou igual ao crítico",
		ident: "estoqueBaixo",
		identFilter: "filterEstoqueBaixo",
		identReport: "reportEstoqueBaixo",
		tableColumns: [
			{ key: "id_produto", label: "ID", align: "center" },
			{ key: "ean", label: "EAN", align: "center" },
			{ key: "referencia", label: "Referência", align: "left" },
			{ key: "nome", label: "Descrição", align: "left" },
			{ key: "qtatual", label: "Estoque", align: "center" },
			{ key: "qtcritica", label: "Estoque Mín.", align: "center" },
			{ key: "valor", label: "Valor", align: "center", format: "currency" },
		],
		reportColumns: [
			{ key: "id_produto", label: "ID", align: "center" },
			{ key: "ean", label: "EAN", align: "center" },
			{ key: "referencia", label: "Referência", align: "left" },
			{ key: "nome", label: "Descrição", align: "left" },
			{ key: "qtatual", label: "Estoque", align: "center" },
			{ key: "qtcritica", label: "Estoque Mín.", align: "center" },
			{ key: "valor", label: "Valor", align: "right", format: "currency" },
		],

		showTime: false, // Não precisa de hora para estoque
		hasActive: false,
		hasSaleType: false,
		parametersDate: [{ id: 1, label: "Filtro", value: "snapshot" }], // Placeholder para não quebrar o layout
		parametersFilter: [
			{ id: 1, label: "Descrição", value: "nome" },
			{ id: 2, label: "Referência", value: "referencia" },
		],
		listDataTotal: [],
	};

	const fetch = async (filterData, newPage, perPage = 15) => {
		const newFilterData = { ...filterData, page: newPage, perPage };

		const response = await reqProduto.listLowStock(newFilterData);

		return response;
	};

	return (
		<div className="flex flex-col mt-14 min-h-[calc(100vh-6.5rem)]">
			<MainReportMatrix options={options} fetch={fetch} FormFilter={FilterReportDateItens}></MainReportMatrix>
		</div>
	);
};

export default ReportEstoqueBaixo;
